import { useGetOne } from "./useGetOne";
import { UnassignedDeliveryContent } from "../api/unassigned_delivery_contents";

export const useUnassignedDeliveryContents = (id: number | undefined) =>
  useGetOne<UnassignedDeliveryContent[]>("amend_unassigned_delivery_counts", id);
export const useSpotContractUnassignedDeliveryContents = (id: number | undefined) =>
  useGetOne<UnassignedDeliveryContent[]>("spot_contract_amend_unassigned_delivery_counts", id);
